<template>
    <section class="barocare-b2c-service-intro" id="barocare-b2c-service-intro">
        <div class="intro-cont">
            <div class="barocare-b2c-container-md">
                <div class="title-area" v-intersect>
                    <span class="text-primary">장애인과 어르신을 위한</span>
                    <h2 class="text-xl">국내 유일 비대면진료<br>바로돌봄</h2>
                </div>
                <div class="item-group-row">
                    <div class="item" v-intersect>
                        <strong class="title">장애인, 어르신을 위한 특화 서비스</strong>
                        <p class="text">바로돌봄은 장애인 및 장기요양등급인정자를 위한<br>비대면진료, 약배달 중개 서비스입니다.</p>
                        <img class="image" src="../../assets/pc_barocare_b2c/intro-cont01.jpg" alt=""/>
                    </div>
                    <div class="item-group">
                        <div class="item" v-intersect>
                        <img class="image" src="../../assets/pc_barocare_b2c/intro-cont02.jpg" alt=""/>
                            <strong class="title">비대면진료와 약 배송 모두 가능</strong>
                            <p class="text">바로돌봄을 통해 원하는 장소에서 의사를 비대면으로 만나고<br>처방약을 집으로 배송받을 수 있어요.</p>
                        </div>
                        <div class="item" v-intersect>
                        <img class="image" src="../../assets/pc_barocare_b2c/intro-cont03.jpg" alt=""/>
                            <strong class="title">바로돌봄 코디가 도와드려요</strong>
                            <p class="text">이용문의, 비대면진료예약 등 바로돌봄 이용에 필요한<br>모든 과정을 전담 상담원이 도와드려요.</p>
                        </div>
                    </div>
                </div>
                <ul class="item-group-row" v-intersect>
                    <li class="ico-item">
                        <div class="img"><img class="image" src="../../assets/pc_barocare_b2c/intro-cont04.png" alt=""/></div>
                        <strong>언제 어디서나 편하게</strong>
                        <p>원하는 장소, 원하는 시간에<br>비대면진료가 가능해요</p>
                    </li>
                    <li class="ico-item">
                        <div class="img"><img class="image" src="../../assets/pc_barocare_b2c/intro-cont05.png" alt=""/></div>
                        <strong>10명 중 9명이 재사용</strong>
                        <p>고객 친화적 서비스로 사용자의<br>90% 이상이 재이용하고 있어요.</p>
                    </li>
                    <li class="ico-item">
                        <div class="img"><img class="image" src="../../assets/pc_barocare_b2c/intro-cont06.png" alt=""/></div>
                        <strong>처방약 배송</strong>
                        <p>처방약은 원하는 장소로<br>배송받을 수 있어요.</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="alliance-slide-cont">
            <div class="title-area" v-intersect>
                <span class="text-primary">바로돌봄 제휴 의료기관 소개</span>
                <h2 class="text-xl">수많은 의료기관이<br>바로돌봄과 함께합니다</h2>
            </div>    
            <div class="slide-wrap" v-intersect>
                <ul class="alliance-list to-right">
                    <li v-for="item in repeatedItems1" :key="item.id">
                        <img :src="item.imageUrl" :alt="item.altText">
                    </li>
                </ul>
                <ul class="alliance-list to-left">
                    <li v-for="item in repeatedItems2" :key="item.id">
                        <img :src="item.imageUrl" :alt="item.altText">
                    </li>
                </ul>
            </div>
            <div class="btn-area" v-intersect>
                <a 
                    href="http://pf.kakao.com/_xhcxkQG/friend"
                    target="_blank" title="새창"
                    class="btn-medical"
                >진료 예약 바로가기</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BarocareB2cServiceIntro',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
    data() {
        return {
            items1: [
                { id: 1, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo01.png'), altText: '박정모내과'},
                { id: 2, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo02.png'), altText: '참이비인후과'},
                { id: 3, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo03.png'), altText: '경대연합의원'},
                { id: 4, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo04.png'), altText: '도브의원'},
                { id: 5, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo05.png'), altText: '곽앤신연합 이비인후과 성형외과 소아청소년과'},
                { id: 6, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo06.png'), altText: '서초아가페의원'},
                { id: 7, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo07.png'), altText: '예소담의원'},
                { id: 8, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo08.png'), altText: '새튼재활의학과의원'},
                { id: 9, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo09.png'), altText: 'Su&Mo PLASTIC SURGERY CLINIC'},
                { id: 10, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo10.png'), altText: '윤수정 클리닉'},
                { id: 11, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo11.png'), altText: '소화연의원'},
                { id: 12, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo12.png'), altText: '움튼산부인과'},
                { id: 13, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo13.png'), altText: '시온뷰티의원'},
                { id: 14, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo14.png'), altText: '연세제일의원'},
                { id: 15, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo15.png'), altText: '연세한결소아청소년과의원'},
                { id: 16, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo16.png'), altText: '연세유원내과'},
                { id: 17, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo17.png'), altText: '동안의원피부과'},
            ],
            items2: [
                { id: 18, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo18.png'), altText: '괴정바른본의원'},
                { id: 19, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo19.png'), altText: '센트럴내과의원'},
                { id: 20, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo20.png'), altText: '사유 정신건강의학과 의원'},
                { id: 21, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo21.png'), altText: '삼성키즈소아청소년과'},
                { id: 22, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo22.png'), altText: '서울배내과'},
                { id: 23, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo23.png'), altText: '다나아내과의원'},
                { id: 24, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo24.png'), altText: '서원교비뇨기과의원'},
                { id: 25, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo25.png'), altText: '고양 신세계안과'},
                { id: 26, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo26.png'), altText: 'SNK clinic'},
                { id: 27, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo27.png'), altText: '트리니티내과'},
                { id: 28, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo28.png'), altText: 'toxnfill'},
                { id: 29, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo29.png'), altText: '조준형내과의원'},
                { id: 30, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo30.png'), altText: '면력한방병원'},
                { id: 31, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo31.png'), altText: '깨끗한속내과'},
                { id: 32, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo32.png'), altText: '바른재활의학과'},
                { id: 33, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo33.png'), altText: '한성연합내과의원'},
            ],
            repeatCount: 3
        }
    },
    computed: {
        repeatedItems1() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items1.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        },
        repeatedItems2() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items2.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cServiceIntro.vue